import { render } from "./VideoForm.vue?vue&type=template&id=38771669&scoped=true&ts=true"
import script from "./VideoForm.ts?vue&type=script&lang=ts"
export * from "./VideoForm.ts?vue&type=script&lang=ts"

import "./VideoForm.scss?vue&type=style&index=0&id=38771669&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38771669"]])

export default __exports__